module.exports = __webpack_public_path__ + "static/media/atsl.d9691bf4.svg";